import Image from 'next/image';
import React from 'react';
import { connect } from 'react-redux';
import { jumpToInput } from '../../../actions/baseActions';

export interface ICompanyImageProps {
	src: string;
	jumpToInput: () => void;
}

const CompanyImage: React.FC<ICompanyImageProps> = (props) => {
	return (
		<div onClick={() => props.jumpToInput()}>
			<Image
				style={{ width: 'auto', height: 'auto' }}
				width={120}
				height={30}
				src={props.src}
				alt={props.src.split('/')[3].split('.')[0]}
			/>
		</div>
	);
};

export default connect(null, { jumpToInput })(CompanyImage);
